
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './descriptive-adjectives-explanation';
const mainimage = '/Images/adverbadjective1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "descriptiveadjectives" },
];


const DescriptiveAdjectives = () => (
  <GrammarPageLayout
    level="B2"
    title="Descriptive Adjectives"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Descriptive Adjectives Exercises"
    seoDescription="Describe character traits in detail with -ive, -able, -ous and compound adjectives, plus their opposites. B2 level exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);

export default DescriptiveAdjectives;
